<template>
  <div v-if="show" class="i18n-selector">
    <!-- i18n -->
    <a-popover trigger="hover" placement="bottomRight">
      <a-menu
        style="width: 120px"
        slot="content"
        v-model="language"
        @select="languageSelect"
      >
        <a-menu-item key="zh-cn">
          <span>简体中文</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item key="en-us">
          <span>English</span>
        </a-menu-item>
      </a-menu>
      <!-- <a-button shape="circle" class="border-radius-16px flex-wrapper-all-center" >
        <yt-icon name="sys/language" scale="1.5" />
        <span style="padding: 5px">Language</span>
      </a-button> -->
        <img src="../../../static/img/vector.png" style="width: 20px;height: 20px"/>

    </a-popover>
  </div>
</template>

<script>
export default {
  name: 'i18nSelector',
  props: {
    // 初始化列表
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      language: ['zh-cn']
    }
  },
  mounted () {
    // var locale = localStorage.getItem('language') || 'zh-cn'
    var locale = this.$i18n.locale
    this.language[0] = locale
    // this.$i18n.locale = locale
    // moment.locale(locale)
  },
  methods: {
    languageSelect ({ key }) {
      this.$db.save('language', key)
      this.$i18n.locale = key
      // if (this.$route.path === '/login') return
      location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.i18n-selector {
  position: fixed;
  top: 30px;
  right: 60px;
  .ant-input {
    border-radius: 8px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/i18nSelector.vue